export default __webpack_public_path__ + "static/twin-cities-mn-hvac-company-5a9d5060040cd482bad5707db84d6ad3.jpg";